import { Component, Input } from "@angular/core";

@Component({
  selector: "app-relatorio-laudo-pintura",
  templateUrl: "./relatorio-laudo-pintura.component.html",
  styleUrls: ["./relatorio-laudo-pintura.component.scss"],
})
export class RelatorioLaudoPinturaComponent {
  @Input() template;
  elementGroup = [];
  observacaoPintura? = null;
  car = {
    capo: { index: null, status: 0 },
    tetoPintura: { index: null, status: 0 },
    capoTraseiro: { index: null, status: 0 },
    paraLamaDianteiroEsquerdo: { index: null, status: 0 },
    paraLamaDianteiroDireito: { index: null, status: 0 },
    paraChoqueDianteiro: { index: null, status: 0 },
    ldPortaDianteira: { index: null, status: 0 },
    ldPortaTraseira: { index: null, status: 0 },
    ldTraseira: { index: null, status: 0 },
    lePortaDianteira: { index: null, status: 0 },
    lePortaTraseira: { index: null, status: 0 },
    leTraseira: { index: null, status: 0 },
    paraLamaTraseiroEsquerdo: { index: null, status: 0 },
    paraLamaTraseiroDireito: { index: null, status: 0 },
    paraChoqueTraseiro: { index: null, status: 0 },
  };

  constructor() {}

  ngOnChanges() {
    let index = 1;
    if (this.template && this.template.elements) {
      this.template.elements.forEach((e, i) => {
        if (e.type == "SELECT") {
          e.index = index < 10 ? "0" + index.toString() : index.toString();
          index++;
          this.elementGroup.push({
            element: e,
            obs: this.template.elements.find(
              (eObs) => eObs.name == e.name + "Obs" && eObs.type == "TEXT"
            ),
          });
          e.status = e.status || 0;
          if (this.car[e.name]) {
            this.car[e.name].status = e.status;
            this.car[e.name].index = e.index;
          }
        }
      });
    }

    this.observacaoPintura = this.template.elements.find(
      (eObs) => eObs.name == "observacaoPintura"
    );
  }
}
